import { computed, inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENDPOINTS } from '@constants/endpoints';
import { apiRequestContext } from '@tokens/api-request.token';
import { firstValueFrom } from 'rxjs';
import { CurrentUser } from '@domain/user/current-user';
import { CurrentUserDto } from '@domain/user/current-user.dto';
import { DEFAULT_FULL_CODE_LOCALE, DEFAULT_LOCALE } from '@constants/default-locale';
import { LOCALE_FULL_CODE_MAP } from '@constants/app-locales';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  private http = inject(HttpClient);

  protected _user = signal<CurrentUser | null>(null);
  user = this._user.asReadonly();
  locale = computed(() => this._user()?.locale || DEFAULT_LOCALE);
  localeFullCode = computed(() => LOCALE_FULL_CODE_MAP[this.locale()] || DEFAULT_FULL_CODE_LOCALE);

  protected async getCurrentUser() {
    return firstValueFrom(this.http.get<CurrentUserDto>(ENDPOINTS.currentUser(), { context: apiRequestContext() }));
  }

  async initialize() {
    const user = await this.getCurrentUser();
    this._user.set(CurrentUser.create(user));
  }
}
